import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { IsFiltersOpenedStateService } from '../../services/is-filters-opened-state.service';


@Component({
  selector: 'filters-list-toggle',
  templateUrl: './filters-list-toggle.component.html',
  styleUrls: ['./filters-list-toggle.component.sass']
})
export class FiltersListToggleComponent implements OnInit {

  @Output() stateChanged: EventEmitter<boolean>;
  public showFilters: boolean = false;

  constructor(private toggleFilters: IsFiltersOpenedStateService) {
    this.stateChanged = this.toggleFilters.getFiltersCurrentStateEmitter() as any as EventEmitter<boolean>;
  }

  ngOnInit() {
    this.toggleFilters.getFiltersCurrentStateEmitter().subscribe((newState: boolean) => {
      this.showFilters = newState;
    })
  }

  emitToggleState() {
    this.showFilters = !this.showFilters;
    this.toggleFilters.getFiltersCurrentStateEmitter().emit(this.showFilters);
  }
}

